// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__Wg4hA","icon":"style_icon__3j97o","title":"style_title__2kaV9","logo":"style_logo__M3e6b","logoContainer":"style_logoContainer__cRKg1"};